/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item/base-carousel-item.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const CarouselItemFragment = gql`
  ${BaseCarouselItemFragment}
  ${BaseImageFragment}
  ${BaseVideoFragment}

  fragment CarouselItemFragment on CarouselItem {
    ...BaseCarouselItemFragment

    media {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
  }
`;
